export enum AuthError {
  InvalidLogin = 310,
}

export enum CashierError {
  NoCashierAndHasOrder = 1004,
}
